import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq({ faqs, label = "Common questions", num = "" }) {
  return (
    <section className="border-t border-border bg-linen py-24">
      <div className="mx-auto max-w-3xl px-6">
        <div className="overline mb-4">{num} {label}</div>
        <h2 className="mb-10 font-serif text-4xl text-ink sm:text-5xl">Before you <span className="italic text-clay">ask.</span></h2>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-border">
              <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-serif text-xl text-ink hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="font-sans text-base leading-relaxed text-ink-soft">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
